<div class="create-folder-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <div class="header-icon">
      <mat-icon>create_new_folder</mat-icon>
    </div>
    <h2>Create Folder</h2>
    <button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="dialog-content" [formGroup]="createForm">
    <div class="form-field">
      <label class="form-label">Folder Name</label>
      <input
        type="text"
        id="name"
        formControlName="name"
        (keyup.enter)="save()"
        class="form-control"
        placeholder="Enter folder name"
        name="name"
        />
      <app-validation-error
        [formGroup]="createForm"
        [controlName]="'name'"
      ></app-validation-error>
    </div>

    <div class="form-field checkbox-field">
      <label class="checkbox-label">
        <input type="checkbox" formControlName="is_virtual" class="checkbox-input">
        <span class="checkbox-text">ShortCut Folder</span>
      </label>
    </div>

    @if (createForm.get('is_virtual')?.value) {
      <div class="form-field">
        <label class="form-label">Module</label>
        <ng-select
          [items]="moduleOptions"
          placeholder="Select Module"
          [closeOnSelect]="true"
          formControlName="show_module_id_data"
          bindValue="id"
          bindLabel="name"
          class="form-control"
          >
        </ng-select>
        <app-validation-error
          [formGroup]="createForm"
          [controlName]="'show_module_id_data'"
        ></app-validation-error>
      </div>
    }
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button class="btn-submit" (click)="save()" [disabled]="isSaving">
      @if (isSaving) {
        <mat-spinner diameter="16"></mat-spinner>
      } @else {
        <mat-icon>save</mat-icon>
      }
      <span>{{ isSaving ? 'Saving...' : 'Save' }}</span>
    </button>
  </div>
</div>
